var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKalianLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-lab-flask 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0721 16V24.8764L29.3797 32.44C30.5758 34.1443 29.99 36.3871 28.0713 37.4495C27.4241 37.8079 26.677 37.9986 25.9143 38H16.0995C13.8385 38.0028 12.0031 36.377 12 34.3687C11.9989 33.6869 12.2137 33.0186 12.6197 32.44L17.9273 24.8764V16",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 25H18",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 19,
    y: 6,
    width: 4,
    height: 8,
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 20",
    x: 18,
    y: 4,
    width: 6,
    height: 2,
    rx: 1,
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 19",
    d: "M14 14H28V15C28 15.5523 27.5523 16 27 16H15C14.4477 16 14 15.5523 14 15V14Z",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M23 9.5H27.25C30.4256 9.5 33 12.0744 33 15.25V15.25C33 18.4256 30.4256 21 27.25 21H14.25C11.9028 21 10 22.9028 10 25.25V25.25C10 27.5972 11.9028 29.5 14.25 29.5H14.5",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalianLogo);
export default __webpack_public_path__ + "static/media/kalian-logo.5880c34293ac73186e1e3b4e1acef0de.svg";
export { ForwardRef as ReactComponent };